import React from 'react';
import { FormattedMessage } from 'react-intl';

import { EPage } from '@types';

import { PAGES } from '../../../constants';
import { useRedirect } from '../../../hooks';
import { IStep } from '../../layouts';

import { IAvailableStep, IRoutingMessages } from './model';

export const getCheckoutSteps = (isLogged: boolean, steps: IAvailableStep[], page: EPage): IStep[] => {
  return steps.reduce((arr: IStep[], current) => {
    if (current.page === EPage.CART_LOG_IN && isLogged) {
      return arr;
    }

    const isCurrentPath =
      PAGES[page]?.internal !== undefined
        ? PAGES[page]?.internal === current.path
        : PAGES[page]?.external === current.path;

    arr.push({
      text: current.component,
      isActive: isCurrentPath,
      disabled: current.activePages.includes(page),
      onClick: isCurrentPath ? undefined : current.onClick,
    });

    return arr;
  }, []);
};

export const useGetAvailableSteps = (messages: IRoutingMessages): IAvailableStep[] => {
  const redirect = useRedirect();

  return [
    {
      component: <FormattedMessage {...messages.pickDiscount} />,
      page: EPage.UPSELLING,
      path: PAGES[EPage.UPSELLING]?.internal,
      onClick: () => redirect(EPage.UPSELLING),
      activePages: [],
    },
    {
      component: <FormattedMessage {...messages.enterEmail} />,
      page: EPage.CART_LOG_IN,
      path: PAGES[EPage.CART_LOG_IN]?.external,
      onClick: () => redirect(EPage.CART_LOG_IN),
      activePages: [EPage.UPSELLING],
    },
    {
      component: <FormattedMessage {...messages.payment} />,
      page: EPage.DELIVERY_AND_PAYMENT,
      path: PAGES[EPage.DELIVERY_AND_PAYMENT]?.internal,
      onClick: () => redirect(EPage.DELIVERY_AND_PAYMENT),
      activePages: [EPage.UPSELLING, EPage.CART_LOG_IN],
    },
    {
      component: <FormattedMessage {...messages.deliveryAddress} />,
      page: EPage.SUMMARY,
      path: PAGES[EPage.SUMMARY]?.internal,
      onClick: () => redirect(EPage.SUMMARY),
      activePages: [EPage.UPSELLING, EPage.CART_LOG_IN, EPage.DELIVERY_AND_PAYMENT],
    },
    {
      component: <FormattedMessage {...messages.orderSummary} />,
      page: EPage.THANK_YOU,
      path: PAGES[EPage.THANK_YOU]?.internal,
      activePages: [EPage.UPSELLING, EPage.CART_LOG_IN, EPage.DELIVERY_AND_PAYMENT, EPage.SUMMARY],
    },
  ];
};
